import { z, type ZodType } from '@customerio/hydra-validation';
import type { TransactionalMessage as ApiTransactionalMessage } from '@customerio/hydra-ui-api';
import { defineEntity } from '../shared/define-entity';

/**
 * Transactional message entity — workspace-scoped.
 *
 * Minimal detail-only entity: `id` normalized to `string` (the wire ships a
 * number). A list+mutation surface and date transforms can be added when a
 * consumer needs them.
 */
export type TransactionalMessage = Omit<ApiTransactionalMessage, 'id'> & { id: string };

const TransactionalMessageFromApi = z.looseObject({
  id: z.number().transform(String),
}) as unknown as ZodType<TransactionalMessage, unknown>;

/** @public */
export const transactionalMessage = defineEntity<TransactionalMessage>({
  name: 'transactional_message',
  scope: 'workspace',
  pk: (m) => m.id,
  schema: { read: TransactionalMessageFromApi },
});

export const transactionalMessageKeys = transactionalMessage.keys;

export function parseTransactionalMessage(raw: ApiTransactionalMessage): TransactionalMessage {
  return transactionalMessage.parse(raw);
}
